/*
 *
 * File JS per la pagina di Archivio Blog
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import archiveFilters from "components/archive-filters/archive-filters";
import archiveList from "components/archive-list/archive-list";
import modalArtists from "components/modal-artists/modal-artists";

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./archive.scss";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();
modalArtists();

//--------------------------------------------------------------------//

// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//
